import {AbstractReactComponent} from 'mc/lib';
import React from 'react';
import {browserHistory} from 'react-router';
import {Card, Col, Row} from 'reactstrap';
import {NewPasswordForm} from '../components';

export default class PasswordResetPage extends AbstractReactComponent {
    render() {
        return <Row className="login-page">
            <Col xs={12} sm={{size: 8, offset: 2}} md={{size: 6, offset: 3}} xl={{size: 4, offset: 4}}>
                <Card block>
                    <NewPasswordForm onComplete={() => browserHistory.push(serverContextPath + '/login')}  />
                </Card>
            </Col>
        </Row>
    }
}
